/**
 * Family bonding activity type definitions and default state.
 */

export interface FamilyActivity {
  id: string;
  title: string;
  description?: string;
  icon: string;
  category: string;
  partnerId?: string;
  displayOrder?: number;
  isCustom?: boolean;
}

export interface FamilyBondingState {
  completedActivities: string[];
  lastResetDate: string | null;
  customActivities: FamilyActivity[];
  dismissedActivities: string[];
  hasSeenFeature: boolean;
}

export const DEFAULT_FAMILY_BONDING_STATE: FamilyBondingState = {
  completedActivities: [],
  lastResetDate: null,
  customActivities: [],
  dismissedActivities: [],
  hasSeenFeature: false,
};
